import { module } from 'modujs';
import modularLoad from 'modularload';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.ajaxurl = '/wp/wp-admin/admin-ajax.php';
    }

    init() {
        const load = new modularLoad({
            enterDelay: 500,
        });

        load.on('loaded', (transition, oldContainer, newContainer) => {
            // $.ajax({
            //     url: this.ajaxurl,
            //     type: 'POST',
            //     data: {
            //         action: "update_shortcode_content"
            //     },
            //     success: function( response ){
            //         $('.b-facebook').html(response.content);
            //     },
            // });
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');
        });

        load.on('loading', (transition, oldContainer) => {
          html.classList.remove('has-navOpen');
          html.classList.remove('has-flapOpen');
          html.classList.remove('has-menuOpen');
          html.classList.remove('has-searchOpen');
          html.classList.add('is-transitioning');
        });

        load.on('ready', (transition, newContainer) => {
          html.classList.add('is-transitioned');
          html.classList.remove('is-transitioning');
        });
    }
}
